<template>
  <div class="container">
    <div class="user">
      <LoadingSkeletonBase :height="25" />
    </div>
    <div class="organization">
      <LoadingSkeletonBase :height="25" />
    </div>
    <div class="avatar">
      <LoadingSkeletonBase
        class="loader"
        :speed="1"
        :height="20"
        :width="20"
      >
        <circle
          cx="10"
          cy="10"
          r="7"
        />
      </LoadingSkeletonBase>
    </div>
  </div>
</template>

<script>
import LoadingSkeletonBase from '../../../common/misc/loading-skeleton/base/LoadingSkeletonBase.vue';

export default {
  name: 'UserButtonLoader',
  components: { LoadingSkeletonBase },
};
</script>

<style lang="scss" scoped>
  .container {
    display: grid;
    grid-template-areas: "name avatar" "org avatar";
    padding: 0;
    grid-template-columns: 150px 60px;

    .avatar {
      grid-area: avatar;
      align-self: center;
    }

    .user {
      @media (max-width: $smallBreakpoint) {
        display: none;
      }

      padding-right: 10px;
      grid-area: name;
      align-self: end;
    }

    .organization {
      @media (max-width: $smallBreakpoint) {
        display: none;
      }

      padding-right: 10px;
      grid-area: org;
      align-self: start;
    }
  }

</style>
